import { useReactOidc } from "@axa-fr/react-oidc-context";
import { User } from "oidc-client";
import { useState, useEffect } from "react";

export function useIsAuthenticated() {
  const { oidcUser, logout } = useReactOidc();
  const [user, setUser] = useState<User | undefined>(undefined);

  const logoff = () => {
    sessionStorage.removeItem("@authentication");
    logout();
  };

  useEffect(() => {
    if (oidcUser) {
      sessionStorage.setItem("@authentication", JSON.stringify(oidcUser));
    }

    setUser(
      oidcUser ??
        (sessionStorage.getItem("@authentication")
          ? JSON.parse(sessionStorage.getItem("@authentication") ?? "")
          : undefined)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { user, logoff };
}
